import React, { memo, useState } from "react";
import { Stack } from "investira.react.components";
import ConcentracaoGroup from "./ConcentracaoGroup";
import ConcentracaoDetalhesDialog from "./ConcentracaoDetalhesDialog";

const Concentracao = memo((props) => {
  const { segmentos, detalhe, variant } = props;
  const [regra, setRegra] = useState({});

  return (
    <Stack component="section" sx={{ gap: 2 }}>
      <ConcentracaoGroup
        segmentos={segmentos}
        detalhe={detalhe}
        onSetRegra={setRegra}
        variant={variant}
      />
      <ConcentracaoDetalhesDialog
        segmentos={segmentos}
        detalhe={detalhe}
        regra={regra}
        onSetRegra={setRegra}
        variant={variant}
      />
    </Stack>
  );
});

export default Concentracao;
